import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

export const useCreateCSVExtended = () => {
  return useGenericRequestHandler({
    route: 't/createCSVExtended',
    method: 'POST',
    options: { timeout: 60 * 3000 }
  })
}
